import { faSave } from "@fortawesome/pro-solid-svg-icons"
import HeroButton from "../common/HeroButton"
import HeroButtonsContainer from "../common/HeroButtonsContainer"
import HeroContainer from "../common/HeroContainer"
import TemplateForm from "./TemplateForm"
import { useState } from "react"
import { useTemplate } from "./templateQueries"

type Props = {
  templateId: number
  heroImage: string
  showDeletedView: boolean
  templateHasChanges: boolean
  onChange: (hasChanges: boolean) => void
  onTemplateDeletionChange: () => void
  onSave: (id: number) => void
}

const EditTemplateView = ({templateId, heroImage, showDeletedView, templateHasChanges, onChange, onTemplateDeletionChange, onSave}: Props) => {
  const [saveCounter, setSaveCounter] = useState<number>(0)
  const templateQuery = useTemplate(templateId, showDeletedView)

  const templateName = templateId == 0
    ? 'New Template'
    : templateQuery.data?.name ?? ''

  return <div style={{flexBasis: '100%', marginLeft: '28px'}}>
    <HeroContainer imgSrc={heroImage} />
    <div className="hero-details">
      <h1>{templateName}</h1>
      {showDeletedView && <h1 className="hero-details-deleted-item">
          <span>
              <span className="margin-30">DELETED</span>
              <br />
              <small className="display-none-tiny">(click on "Restore" to un-delete it)</small>
          </span>
      </h1>}
      {!showDeletedView && <HeroButtonsContainer>
        <HeroButton icon={faSave} onClick={() => setSaveCounter(saveCounter + 1)} disabled={!templateHasChanges} />
      </HeroButtonsContainer>}
    </div>
    <section>
      <TemplateForm
        onChange={onChange}
        onSave={onSave}
        onDelete={onTemplateDeletionChange}
        onRestore={onTemplateDeletionChange}
        saveCounter={saveCounter}
      />
    </section>
  </div> 
}

export default EditTemplateView